import React from 'react'

const ResearchAndDevelopment = () => {
    return (
        <div>
            <h3 className="text-3xl text-center font-normal py-4">
                Research and Development
            </h3>

            <div className="w-[96%] bg-[#f5eeee76] mx-auto mt-8 rounded-lg p-5 font-sans">
                <div className="px-6 md:px-24">
                    <h2 className="mt-5 mb-2 font-semibold text-xl">
                        This page is currently under development
                    </h2>
                </div>
            </div>
        </div>
    )
}

export default ResearchAndDevelopment
